import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../../webcommon/common/formcomponents/textinput/TextInput';
import SearchIcon from '../../../../webcommon/common/Icons/Search.svg';
import classnames from 'classnames';
import { noop } from 'lodash';
import defaultStyles from './TradePricedHeader.module.scss';

const TradePricedHeader = props => (
    <div className={ props.styles.tradePricedTodayHeader }>
        <div className={ classnames({
            [props.styles.headerTitle]: !props.changesInTradeSelection || props.readOnly,
            [props.styles.redTitle]: !props.readOnly && props.changesInTradeSelection
        }) }
        >
            Trade Priced Today
        </div>
        <div className={ props.styles.separator }>&nbsp;</div>
        <div className={ props.styles.tradeSearchbox }>
            <TextInput
                value={ props.searchValue }
                onChange={ e => props.setTradeSearchString(e.target.value) }
                placeholder="Search Trades"
                icon={ SearchIcon }
            />
        </div>
    </div>
);

TradePricedHeader.propTypes = {
    changesInTradeSelection: PropTypes.bool,
    setTradeSearchString: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    searchValue: PropTypes.string,
    readOnly: PropTypes.bool
};

TradePricedHeader.defaultProps = {
    changesInTradeSelection: false,
    searchValue: '',
    setTradeSearchString: noop,
    styles: defaultStyles,
    readOnly: false
};

export default TradePricedHeader;
